import { render, staticRenderFns } from "./VideoPlayPause.vue?vue&type=template&id=28280635&scoped=true&"
import script from "./VideoPlayPause.vue?vue&type=script&lang=js&"
export * from "./VideoPlayPause.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayPause.vue?vue&type=style&index=0&id=28280635&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28280635",
  null
  
)

export default component.exports